import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { BrandingComponent } from './branding.component';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule } from '@angular/forms';
import { AppNavItemComponent } from './nav-item/nav-item.component';
import { NgScrollbarModule } from "ngx-scrollbar";
import { HasPermissionDirective } from 'src/app/directives/has-permission.directive';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TokenService } from 'src/app/core/services/token.service';

@Component({
  selector: 'app-sidebar',
  imports: [
    BrandingComponent,
    TablerIconsModule,
    MaterialModule,
    FormsModule,
    AppNavItemComponent,
    NgScrollbarModule,
    HasPermissionDirective,
    TranslateModule,
  ],
  templateUrl: './sidebar.component.html'
})
export class SidebarComponent implements OnInit, OnChanges {
  @Input() showToggle = true;
  @Input() items: any[] = [];
  @Output() toggleMobileNav = new EventEmitter<void>();
  @Output() toggleCollapsed = new EventEmitter<void>();

  searchText: string = '';
  filteredItems: any[] = [];
  private langCode: string = 'ar';
  userId: number;

  constructor(private translate: TranslateService,
    private tokenService: TokenService,

  ) {
    let lang: any = localStorage.getItem('lang');
    let langObj: any;
    if (lang != undefined && lang != null) {

      langObj = JSON.parse(lang);
      this.langCode = langObj.code;
    }
    else {
      this.langCode = 'ar';
    }
    this.translate.use(this.langCode);
    this.userId = this.tokenService.getUserIdFromToken();
  }
  ngOnInit(): void {
    // Read language from localStorage
    const lang = localStorage.getItem('lang');
    if (lang) {
      try {
        const langObj = JSON.parse(lang);
        this.langCode = langObj.code || 'ar';
      } catch {
        this.langCode = 'ar';
      }
    }

    this.initializeMenu();
  }

  ngOnChanges(changes: SimpleChanges): void {
    //  When "items" changes externally, update the menu
    if (changes['items'] && changes['items'].currentValue) {
      this.initializeMenu();
    }
  }

  private initializeMenu(): void {
    if (this.items && this.items.length > 0) {
      this.patchNames(this.items);

      // If search text exists, apply filtering immediately
      if (this.searchText.trim()) {
        this.onSearchChange(this.searchText);
      } else {
        this.filteredItems = [...this.items];
      }
    }
  }

  patchNames(items: any[]) {
    items.forEach(item => {
      if (!item.nameEn) item.nameEn = item.displayName;
      if (!item.nameAr) item.nameAr = item.displayName;

      if (item.children) this.patchNames(item.children);
    });
  }

  onSearchChange(text: string) {
    const lower = text.toLowerCase().trim();

    if (!lower) {
      this.filteredItems = [...this.items];
      return;
    }

    this.filteredItems = this.filterMenu(this.items, lower);
  }

  filterMenu(items: any[], search: string): any[] {
    return items
      .map(item => {
        const nameEn = item.nameEn?.toLowerCase() ?? '';
        const nameAr = item.nameAr?.toLowerCase() ?? '';
        const displayName = item.displayName?.toLowerCase() ?? '';

        // 🔍 Search in all name fields
        const matches =
          nameEn.includes(search) ||
          nameAr.includes(search) ||
          displayName.includes(search);

        if (matches) {
          return { ...item, expanded: true };
        }

        if (item.children && item.children.length > 0) {
          const kids = this.filterMenu(item.children, search);

          // If children contain matches, keep them
          if (kids.length > 0) {
            return {
              ...item,
              children: kids,
              expanded: true
            };
          }
        }

        return null;
      })
      .filter(x => x !== null) as any[];
  }
}
